var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetch } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, handleResponse, HttpMethodType, CaseFormatter, HttpCacheType, HttpContentType, HttpHeaderType } from "../../common";
export class VehicleService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
    }
    static getInstance() {
        if (VehicleService.INSTANCE == null) {
            VehicleService.INSTANCE = new VehicleService();
        }
        return VehicleService.INSTANCE;
    }
    /**
     * Method to retrieve vehicle information for job
     * @param jobUId
     * @returns SAGASERVICEONLY_IVehicle
     */
    GetJobVehicleData(jobUId) {
        const url = VehicleService.getJobVehicleUrl(jobUId);
        return this.fetchWrapper(new Request(url, VehicleService.generateRequestInit(HttpMethodType.GET))).then(response => handleResponse(response));
    }
    SaveJobVehicleData(jobUId, jobVehicleData, companyDefinedFieldsRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = VehicleService.getJobVehicleUrl(jobUId);
            // Before case formatter is run store the copy since we dont want vehicle options
            // to go through case formatter
            const vehicleOptions = Object.assign({}, jobVehicleData.vehicleOptionsInfo);
            jobVehicleData = CaseFormatter.camelToPascalCase(jobVehicleData);
            let formattedJobVehicleData = Object.assign(Object.assign({}, jobVehicleData), { VehicleOptionsInfo: vehicleOptions });
            if (companyDefinedFieldsRequestPayload) {
                Object.assign(formattedJobVehicleData, { companyDefinedFieldsRequestPayload });
            }
            return yield this.fetchWrapper(new Request(url, VehicleService.generateRequestInit(HttpMethodType.POST, JSON.stringify(formattedJobVehicleData)))).then(response => handleResponse(response));
        });
    }
    UpdateJobVehicleData(jobUId, jobVehicleData, companyDefinedFieldsRequestPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = VehicleService.getJobVehicleUrl(jobUId);
            // Before case formatter is run store the copy since we dont want vehicle options
            // to go through case formatter
            const vehicleOptions = Object.assign({}, jobVehicleData.vehicleOptionsInfo);
            jobVehicleData = CaseFormatter.camelToPascalCase(jobVehicleData);
            let formattedJobVehicleData = Object.assign(Object.assign({}, jobVehicleData), { VehicleOptionsInfo: vehicleOptions });
            if (companyDefinedFieldsRequestPayload) {
                Object.assign(formattedJobVehicleData, { companyDefinedFieldsRequestPayload });
            }
            yield this.fetchWrapper(new Request(url, VehicleService.generateRequestInit(HttpMethodType.PUT, JSON.stringify(formattedJobVehicleData)))).then(response => handleResponse(response));
        });
    }
    static generateRequestInit(httpMethod, body) {
        return {
            method: httpMethod,
            headers: new Headers({
                [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON,
                Pragma: HttpCacheType.NO_CACHE
            }),
            body: body
        };
    }
    static getJobVehicleUrl(jobUId) {
        return EnvironmentService.getEnvironment().appApi + 'Jobs/' + jobUId + '/Vehicles';
    }
}
//# sourceMappingURL=VehicleService.js.map